// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const CheckmarkSmallIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="CheckmarkSmallIcon" ref={forwardedRef} {...props}>
      <path d="M15.218 7.282 8.5 14l-3.536-3.536 1.061-1.06L8.5 11.879l5.657-5.657z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const CheckmarkSmallIcon = /* @__PURE__ */ Object.assign(
  CheckmarkSmallIconComponent,
  { displayName: 'CheckmarkSmallIcon' },
);
